import { Heading, Paragraph } from "@digdir/designsystemet-react";
import "./RapportkatalogCardTitle.css";

type RapportkatalogCardTitleProps = {
    title: string;
};

export function RapportkatalogCardTitle({ title }: RapportkatalogCardTitleProps) {
    return (
        <div className="rapportkatalog-card-title">
            <Paragraph className="rapportkatalog-card-title-label">Tittel</Paragraph>
            <Heading level={2} data-size="md">
                {title || "-"}
            </Heading>
        </div>
    );
}
